import { FunctionComponent, h } from 'preact';
import Button from '../../button/button';

interface Props {
	children?: JSX.Element | JSX.Element[];
	onOk: () => void;
	title: string | JSX.Element;
	okText: string | JSX.Element;
}

const SuccessContent: FunctionComponent<Props> = ({ children, title, onOk, okText }) => {
	return (
		<div className="success-content" data-testid="success-content">
			<div className="title aria-focus" tabIndex={0}>
				{title}
			</div>
			{children}
			<Button className="filled-button" onClick={onOk}>
				<div>{okText}</div>
			</Button>
		</div>
	);
};

export default SuccessContent;
